import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import ReactJson from "react-json-view";

import { gql } from "apollo-boost";

const UPDATE_INTERVAL = 15 * 1000; // 15 seconds

const MODELS_QUERY = gql`
  query listModels($nextToken: String) {
    listModels(nextToken: $nextToken) {
      items {
        name
        version
        status
        architecture
        training
        messages
        loss
        timestamp
      }
      nextToken
    }
  }
`;

const fetchModels = async (
  client,
  models,
  setModels,
  nextToken,
  setNextToken
) => {
  let variables = {
    nextToken
  };
  const queryResults = await new Promise((resolve, reject) => {
    client
      .query({
        query: MODELS_QUERY,
        variables: variables,
        fetchPolicy: "no-cache"
      })
      .then(result => resolve(result))
      .catch(err => reject(err));
  });

  const data = queryResults.data.listModels;
  if (data.items.length === 0) {
    setNextToken(null);
  } else {
    setNextToken(data.nextToken);
    setModels(models.concat(data.items));
  }
  return;
};

export default function ModelTable(props) {
  const { client } = props;
  const [models, setModels] = React.useState(null);
  const [nextToken, setNextToken] = React.useState(null);
  const [updateTime, setUpdateTime] = React.useState(null);

  React.useEffect(() => {
    setUpdateTime(new Date());
    if (models === null) {
      fetchModels(client, [], setModels, nextToken, setNextToken);
    } else if (nextToken !== null) {
      fetchModels(client, models, setModels, nextToken, setNextToken);
    }
  }, [client, models, nextToken]);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      fetchModels(client, [], setModels, nextToken, setNextToken);
    }, UPDATE_INTERVAL);
    return () => clearInterval(intervalId);
  }, [client, nextToken]);

  if (models === null) {
    return <React.Fragment />;
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <caption>Last updated: {updateTime.toString()}</caption>
        <TableHead>
          <TableRow>
            <TableCell>Models</TableCell>
            <TableCell align="right">Version</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Architecture</TableCell>
            <TableCell align="right">Training</TableCell>
            <TableCell align="right">Messages</TableCell>
            <TableCell align="right">Loss</TableCell>
            <TableCell align="right">Timestamp</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map(model => (
            <TableRow key={`${model.name}-${model.version}`}>
              <TableCell component="th" scope="row">
                {model.name}
              </TableCell>
              <TableCell align="right">{model.version}</TableCell>
              <TableCell align="right">{model.status}</TableCell>
              <TableCell align="right">
                <ReactJson
                  displayObjectSize={false}
                  displayDataTypes={false}
                  enableClipboard={false}
                  src={JSON.parse(model.architecture)}
                />
              </TableCell>
              <TableCell align="right">
                <ReactJson
                  displayObjectSize={false}
                  displayDataTypes={false}
                  enableClipboard={false}
                  src={JSON.parse(model.training)}
                />
              </TableCell>
              {model.messages && (
                <TableCell align="right">
                  <ReactJson
                    displayObjectSize={false}
                    displayDataTypes={false}
                    enableClipboard={false}
                    src={JSON.parse(model.messages[model.messages.length - 1])}
                  />
                </TableCell>
              )}
              {model.loss && <TableCell align="right">{model.loss}</TableCell>}
              {model.timestamp && (
                <TableCell align="right">{model.timestamp}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}



// WEBPACK FOOTER //
// ./src/sections/models/components/ModelTable.js